import { getAuthToken, getBidderId, logOutBidder } from './user';
import { createSelector } from 'reselect';
import { dismissModal } from './modal';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';
import { postDeleteAccount } from '@/redux/api/bidder';

/* Action Types */
const DELETE_ACCOUNT_FAIL = 'DELETE_ACCOUNT_FAIL';
const DELETE_ACCOUNT_REQUEST = 'DELETE_ACCOUNT_REQUEST';
const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: null,
    submitted: false,
    success: false,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case DELETE_ACCOUNT_FAIL:
            return {
                ...state,
                error: action.payload,
                submitted: false,
                success: false,
            };
        case DELETE_ACCOUNT_REQUEST:
            return {
                ...state,
                error: null,
                submitted: true,
                success: false,
            };
        case DELETE_ACCOUNT_SUCCESS:
            return {
                ...state,
                error: null,
                submitted: false,
                success: true,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.deleteAccount;

export const getDeleteAccountUIState = createSelector(stateSelector, (state) => state);

export const resetAccountDeleteState = () => ({
    type: DELETE_ACCOUNT_SUCCESS,
});

export const submitDeleteAccount = () => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const deployment = getDeployment(state);
        const bidderId = getBidderId(state);
        const authToken = getAuthToken(state);

        dispatch({
            type: DELETE_ACCOUNT_REQUEST,
        });

        await postDeleteAccount({
            authToken,
            bidderId,
            deployment,
        });

        dispatch({
            type: DELETE_ACCOUNT_SUCCESS,
        });
        dispatch(dismissModal());
        dispatch(logOutBidder());
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: DELETE_ACCOUNT_FAIL,
        });
    }
};
